module.exports = __webpack_public_path__ + "img/8934041.jpg";